export function repairState(fold) {
    const { attempts } = fold;
    if (fold.openRepair)
        return { state: 'open', attempts };
    if (attempts === 0)
        return { state: 'none', attempts };
    // Every repair is closed: the current esito is the latest closed one's
    return {
        state: fold.currentEsito === 'positivo' ? 'repaired' : 'failed',
        attempts,
    };
}
/**
 * Whether a repair counts against the inspection: one started and not cancelled,
 * open or closed. From then on the inspection's outcome is no longer the
 * inspector's to correct; a repair started by mistake and cancelled leaves it so.
 */
export const repairExists = (fold) => fold.attempts > 0;
/**
 * A repair started and not closed yet (a cancelled one is closed by its
 * cancellation). More than one can be open: two starters, `Avvia comunque`.
 */
export const isOpenRepair = (phase) => phase.kind === 'repair' && phase.closingId === null;
